/**
 * Les couleurs des cercles de rayon sur les cartes de formateurs : le rayon en
 * cours (orange, comme le repère du lieu) et les anciens rayons d'une zone
 * élargie (gris). Google Maps veut une chaîne hexadécimale : pas de `var()`.
 * Les légendes et l'historique de la zone les reprennent d'ici.
 */
export const COULEUR_RAYON = '#f59e0b'
export const COULEUR_RAYON_ANCIEN = '#6b7280'
